<template>
    <div class="btn-group" role="group" aria-label="Main action and dropdown">
        <button type="button" class="btn btn-sm btn-primary" @click="$emit(actions[main].event)">
            {{ actions[main].title }}
        </button>
        <div class="btn-group" role="group">
            <button
                id="dropdown"
                type="button"
                class="btn btn-sm btn-primary dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            ></button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown">
                <a
                    v-if="widget.payload.id && main !== 'cancel'"
                    class="cursor-pointer dropdown-item small"
                    @click.prevent="$emit('cancel-widget-edit')"
                    >Cancel</a
                >
                <a
                    v-if="!widget.payload.id && !['save', 'add'].includes(main)"
                    class="cursor-pointer dropdown-item small"
                    @click.prevent="$emit('save-widget-new-entry')"
                    >Add</a
                >
                <a
                    v-if="!['save', 'add'].includes(main)"
                    class="cursor-pointer dropdown-item small"
                    @click.prevent="$emit('save-widget-new-entry')"
                    >Save</a
                >
                <a
                    v-if="widget.payload.id && main !== 'delete'"
                    class="cursor-pointer dropdown-item small text-danger"
                    @click.prevent="$emit('delete-widget-entry')"
                    >Delete</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputActionsWidget",
    props: ["widget", "main"],
    data() {
        return {
            actions: {
                save: {
                    title: "Save",
                    event: "save-widget-new-entry",
                },
                add: {
                    title: "Add",
                    event: "save-widget-new-entry",
                },
                cancel: {
                    title: "Cancel",
                    event: "cancel-widget-edit",
                },
                delete: {
                    title: "Delete",
                    event: "delete-widget-entry",
                },
            },
        };
    },
};
</script>

<style scoped></style>
